import React, { useState, useEffect } from 'react';
import '../../App.css';
import { useNavigate } from 'react-router-dom';
import '../Cards.css';
import CardItem from '../CardItem';

export default function Products() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          'https://docs.google.com/spreadsheets/d/1UCvIeiyIjGi1XnBfsMRa_ifSRc6-7B9lm_HKicbq8iw/gviz/tq?tqx=out:csv&sheet=Gallery'
        );
        const text = await response.text();
        const rows = text.split('\n').slice(1);

        const parsedProducts = rows
          .map((row) => {
            const [
              id,
              name,
              description,
              qtyMade,
              qtySold,
              price,
              imgUrl,
              imgId,
              status
            ] = row.split(',');

            const sanitizedImgUrl = imgUrl?.trim().replace(/^"|"$/g, '');
            const trimmedId = id?.trim().toLowerCase();

            if (!trimmedId || !sanitizedImgUrl) return null;

            return {
              id: trimmedId,
              name: name?.trim(),
              description: description?.trim(),
              qtyMade: qtyMade?.trim(),
              qtySold: qtySold?.trim(),
              price: price?.trim(),
              img_url: sanitizedImgUrl,
              status: status?.trim()
            };
          })
          .filter(Boolean);

        setProducts(parsedProducts);
      } catch (err) {
        console.error('Failed to load product data:', err);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="cards">
      <h1>Gallery</h1>
      <div className="cards__container">
        <div className="cards__wrapper">
          {products.reduce((rows, product, index) => {
            if (index % 3 === 0) rows.push([]);
            rows[rows.length - 1].push(product);
            return rows;
          }, []).map((row, rowIndex) => (
            <ul className="cards__items" key={rowIndex}>
              {row.map((product) => (
                <CardItem
                  key={product.id}
                  src={product.img_url}
                  title={product.name}
                  price={product.price}
                  availability={`Made: ${product.qtyMade} | Sold: ${product.qtySold}`}
                  description={product.description}
                  onClick={() =>
                    navigate(`/products/${product.id}`, {
                      state: { product }
                    })
                  }
                />
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
}